import { fmt } from "../../data/mockData";

export default function AccountCard({ account }) {
  const isNeg    = account.balance < 0;
  const changePos = account.change > 0;

  return (
    <div
      style={{
        background: "var(--bg-elevated)",
        border: "1px solid var(--border-strong)",
        borderRadius: "16px",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        cursor: "pointer",
        transition: "all 0.2s",
        position: "relative",
        overflow: "hidden",
      }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = "#D4AF37";
        e.currentTarget.style.transform   = "translateY(-2px)";
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "var(--border-strong)";
        e.currentTarget.style.transform   = "translateY(0)";
      }}
    >
      <div style={{ position: "absolute", top: 0, right: 0, width: "80px", height: "80px", borderRadius: "0 16px 0 80px", background: "rgba(212,175,55,0.06)" }} />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <div style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.1em", textTransform: "uppercase" }}>
            {account.bank}
          </div>
          <div style={{ fontSize: "14px", color: "var(--text-secondary)", marginTop: "2px" }}>{account.name}</div>
        </div>
        <span style={{ fontSize: "24px" }}>{account.icon}</span>
      </div>

      <div>
        <div style={{ fontSize: "24px", fontFamily: "'Capsule Sans', sans-serif", fontWeight: "600", color: isNeg ? "#F87171" : "var(--text-primary)", letterSpacing: "-0.02em" }}>
          {fmt(account.balance)}
        </div>
        <div style={{ fontSize: "12px", color: changePos ? "#52D68A" : "#F87171", fontFamily: "'JetBrains Mono', monospace", marginTop: "4px" }}>
          {changePos ? "▲" : "▼"} {fmt(Math.abs(account.change))} this month
        </div>
      </div>
    </div>
  );
}
